import { Link } from 'react-router-dom';
import { FiHome } from 'react-icons/fi';

const NotFound = () => {
  return (
    <div className="min-h-[calc(100vh-20rem)] flex items-center justify-center py-12 px-4">
      <div className="text-center">
        <h1 className="text-6xl font-heading font-bold text-primary mb-4">404</h1>
        <h2 className="text-2xl font-heading text-gray-900 mb-4">Page not found</h2>
        <p className="text-gray-600 font-body mb-8 max-w-md">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <Link to="/" className="btn-primary inline-flex items-center space-x-2">
          <FiHome />
          <span>Back to home</span>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
